define(
    'utils/local-storage',['jquery'],

    function ($) {
        function LocalStorage () {}

        /**
         * Get a local storage value
         *
         * @method get
         * @param {String} key
         * @param {Boolean} session - get from session insead of local
         */
        LocalStorage.prototype.get = function (key, isSession) {
            var storedValue = isSession ? sessionStorage.getItem(key) : localStorage.getItem(key);

            return JSON.parse(storedValue);
        };

        /**
         * Set a new local storage value.
         *
         * @method set
         * @param {String} key
         * @param {*} value         - will be JSON-stringified and saved.
         * @param {Boolean} session - set session instead of local.
         */
        LocalStorage.prototype.set = function (key, value, isSession) {
            var jsonValue = JSON.stringify(value);

            if (isSession) {
                sessionStorage.setItem(key, jsonValue);
            } else {
                localStorage.setItem(key, jsonValue);
            }

        };

        /**
         * @method delete
         * @param key
         */
        LocalStorage.prototype.delete = function (key, isSession) {
            if (isSession) {
                sessionStorage.removeItem(key);
            } else {
                localStorage.removeItem(key);
            }
        };

        return new LocalStorage();
    }
);

